import { getDay } from 'date-fns/esm'
import { type SimpleSelectOption } from '@workwave-tidal/core/components'
import { dateUtils } from '@/utils'
import { type RecurrenceWhen } from '../../../../types'
import { createRecurrenceWhenId } from './createRecurrenceWhenId'

export function createMonthlyOptions(
  selectedDateYYYYMMDD: uui.domain.YYYYMMDD,
  formatRecurrenceWhenLabel: (recurrenceWhen: RecurrenceWhen) => string,
): SimpleSelectOption<string>[] {
  const selectedDate = dateUtils.parseDate(selectedDateYYYYMMDD)
  const cardinal = dateUtils.getWeekdayCardinality(selectedDate)

  const whenRecurrences: RecurrenceWhen[] = [
    {
      type: 'MONTHLY',
      date: selectedDateYYYYMMDD,
    },
    {
      type: 'MONTHLY',
      date: selectedDateYYYYMMDD,
      cardinal,
      weekday: getDay(selectedDate),
    },
  ]

  // Create array of objects with day index as key and day name as value
  return whenRecurrences.map<SimpleSelectOption<string>>(recurrenceWhen => {
    return {
      value: createRecurrenceWhenId(recurrenceWhen),
      label: formatRecurrenceWhenLabel(recurrenceWhen),
    }
  })
}
